var _effectorFileName = "/src/page-content/individual-lessons/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const individualLessonsPage = declarePage({
  pageType: pagesPath.$url().pathname
});